import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { AuthShell, Field, SubmitBtn } from "../components/AuthShell";

export default function ForgotPassword() {
  const { t, lang } = useI18n();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email, lang });
      toast.success(data.message);
      setDone(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title={t("forgot_title")} subtitle={t("forgot_sub")}>
      {done ? (
        <p className="font-mono text-sm text-nhgreen">✓ Proverite email za link za resetovanje.</p>
      ) : (
        <form onSubmit={submit}>
          <Field label={t("email")} testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          <SubmitBtn loading={loading} testid="forgot-submit">{t("forgot_submit")}</SubmitBtn>
        </form>
      )}
      <p className="font-mono text-xs text-white/50 mt-6 text-center">
        <Link to="/login" className="text-nhgreen hover:underline">{t("nav_login")}</Link>
      </p>
    </AuthShell>
  );
}
